/**
 * Returns true when HTML content has visible text after tags and whitespace entities
 * are stripped. Used to hide the mobile project summary when there is nothing to show.
 */
export const hasVisibleSummaryText = (htmlContent: string): boolean => {
    const text = (htmlContent || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;|&#160;|&#xa0;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    return text.length > 0;
};

export const splitContentByChars = (htmlContent: string) => {
    // 1. Strip HTML tags to get plain text.
    const text = (htmlContent || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    // 2. Word-wrap the plain text to a max of 38 chars per line.
    const lines = [];
    const lineLength = 38;
    const words = text.split(' ');
    let currentLine = '';

    for (const word of words) {
        if (
            currentLine.length +
                word.length +
                (currentLine.length > 0 ? 1 : 0) >
            lineLength
        ) {
            lines.push(currentLine);
            currentLine = word;
        } else {
            if (currentLine.length > 0) {
                currentLine += ' ';
            }
            currentLine += word;
        }
    }

    if (currentLine.length > 0) {
        lines.push(currentLine);
    }

    // 3. Split the lines into two columns and handle overflow.
    const overflow = lines.length > 18;

    const firstColLines = lines.slice(0, 9);
    const secondColLines = lines.slice(9, 17);

    const firstCol = firstColLines.join('\n');
    let secondCol = secondColLines.join('\n');

    if (overflow) {
        secondCol = secondCol.slice(0, -3) + '...';
    }

    return { firstCol, secondCol, isOverflowing: overflow };
};
